import { getInitModel } from "../services/initModels";
import { MODEL_TYPE } from "../utils/enums";

const getDeliveryTimeRangeValue = value => (Number.isFinite(value) ? value : null);

export function businessInfoModel(data) {
    let model = data || {};
    const consumerFacingDeliveryTimeRange = model.consumer_facing_delivery_time_range || {};

    return {
        ...model,
        consumer_facing_delivery_time_range_min: getDeliveryTimeRangeValue(consumerFacingDeliveryTimeRange.min),
        consumer_facing_delivery_time_range_max: getDeliveryTimeRangeValue(consumerFacingDeliveryTimeRange.max),
        address: {
            address: getInitModel(MODEL_TYPE.address, { city: model.address_city, street: model.address }),
            location: getInitModel(MODEL_TYPE.location, model.location)
        },
        modelType: MODEL_TYPE.businessInfoModel
    }
}

export function businessInfoServerModel(data) {
    let model = data || {};
    const address = (model.address && model.address.address) || {};
    const location = (model.address && model.address.location) || {};
    const hasDeliveryTimeRange = "consumer_facing_delivery_time_range_min" in model
        || "consumer_facing_delivery_time_range_max" in model;
    const deliveryTimeRangeMin = getDeliveryTimeRangeValue(model.consumer_facing_delivery_time_range_min);
    const deliveryTimeRangeMax = getDeliveryTimeRangeValue(model.consumer_facing_delivery_time_range_max);

    return {
        name: model.name,
        slug: model.slug,
        email: model.email,
        phone: model.phone,
        city: address.city,
        address: address.street,
        address_notes: model.address_notes,
        zipcode: model.zipcode,
        link: model.link,
        location: {
            lat: location.latitude,
            lng: location.longitude
        },
        kosher: model.kosher,
        minimum: model.minimum,
        always_deliver: model.always_deliver,
        about: model.about,
        description: model.description,
        enabled: model.enabled,
        disable_delivery: model.disable_delivery,
        disable_takeaway: model.disable_takeaway,
        allow_gift: model.allow_gift,
        message: model.message,
        message_enabled: model.message_enabled,
        header_settings: model.header_settings,
        header_mini_settings: model.header_mini_settings,
        disable_scheduled_orders: model.disable_scheduled_orders,
        disable_takeaway_scheduled_orders: model.disable_takeaway_scheduled_orders,
        minimum_takeaway: model.minimum_takeaway,
        disable_cutlery: model.disable_cutlery,
        cutlery_sku: model.cutlery_sku,
        default_product_list_view: model.default_product_list_view,
        general_item_sku: model.general_item_sku,
        temporary_disable_business: model.temporary_disable_business,
        temporary_disable_delivery: model.temporary_disable_delivery,
        temporary_disable_takeaway: model.temporary_disable_takeaway,
        consumer_facing_delivery_time_range: hasDeliveryTimeRange
            ? { Min: deliveryTimeRangeMin, Max: deliveryTimeRangeMax }
            : null,
    }
}
